import { ReactSVG } from "react-svg";
const columns = [
  {
    name: "Stock Code",
    selector: (row) => row.stock_code,
    sortable: true,
    maxWidth: "200px",
  },
  {
    name: "Fabric Image",
    selector: (row) => row,
    sortable: true,
    format: (row) => {
      return (
        <div className="d-flex flex-row" style={{ alignItems: "center" }}>
          <img
            src={row.image}
            style={{
              height: "120px",
              width: "150px",
              borderRadius: "32px",
              marginRight: "16px",
              objectFit: "cover",
            }}
          />
          <div>{row.fabric_name}</div>
        </div>
      );
    },
  },
  // {
  //   name: "Name",
  //   selector: (row) => row.fabric_name,
  //   sortable: true,
  //   maxWidth: "200px",
  // },
  {
    name: "Material",
    selector: (row) => row.pattern,
    sortable: true,
    maxWidth: "200px",
  },
  {
    name: "Product",
    selector: (row) =>
      row.detailProduct === null ? "-" : row.detailProduct.name,
    sortable: true,
    maxWidth: "200px",
  },
  {
    name: "Status",
    selector: (row) => row.status,
    sortable: true,
    maxWidth: "200px",
    format: (row) => {
      return (
        <div
          style={{
            padding: "4px 8px",
            borderRadius: "4px",
            color: row.status === "aktif" ? "#1EB200" : "white",
            backgroundColor: row.status === "aktif" ? "#D5FFCC" : "red",
          }}
        >
          {row.status === "aktif" ? "Active" : "Non-Active"}
        </div>
      );
    },
  },
];

export default columns;
